import EndProcess from "assets/images/fine-processo/Smile_2x.png";

interface Props {
	title?: any;
	text?: any;
	conclusione?: string;
	button?: string;
	onClick: () => void;
	className?: string;
}

const ProcessTerminated: React.FC<Props> = (props) => {
	const { title, text, conclusione, button, onClick } = props;
	return (
		<div className="process-terminated m-lg-0 mt-5 mx-4">
			<div className="row">
				<div className="col-md-6 d-flex justify-content-center align-content-center flex-column">
					<div>
						<div>
							<i className="icon fa-solid fa-check rounded-4 d-flex justify-content-center align-items-center fs-1 mb-4 bg-primary mt-lg-0 mt-3"></i>
						</div>
						<div className="col-md-12">
							<h1>{title}</h1>
						</div>
					</div>
					<div>
						<p className="text-secondary">{text}</p>
						<h6 className="text">
							<u>{conclusione}</u>
						</h6>
						<button className="btn btn btn-dark mt-3" onClick={onClick}>
							{button}
						</button>
					</div>
				</div>
				<div className="col-md-6 order-md-last">
					<img src={EndProcess} className="imageEndProcess ps-5" />
				</div>
			</div>
		</div>
	);
};

export default ProcessTerminated;
